import { render, staticRenderFns } from "./UsersInvite.vue?vue&type=template&id=3119d1c8&scoped=true"
import script from "./UsersInvite.vue?vue&type=script&lang=js"
export * from "./UsersInvite.vue?vue&type=script&lang=js"
import style0 from "./UsersInvite.vue?vue&type=style&index=0&id=3119d1c8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3119d1c8",
  null
  
)

export default component.exports